<template>
    <div>
        <h1 class="display-heading">Medicine Delivery</h1>
        <div ref="tableSection">
            <div class="table-responsive">
                <table ref="listTable" class="table table-hover">
                    <colgroup>
                        <col width="50">
                        <col width="210">
                        <col width="150">
                        <col width="150">
                        <col>
                        <col width="200">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Date Time</th>
                            <th>Status</th>
                            <th>Consultation ID</th>
                            <th>Patient Name</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-show="consultationList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>

                        <tr v-for="(consultation, index) in consultationList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>

                            <td class="text-nowrap">
                                {{ consultation.dateTime }}
                            </td>
                            <td>
                                <span class="badge text-nowrap" :class="getMedicineChargesBadgeClass(consultation.status)">
                                    {{getMedicineChargesStatus(consultation.status)}}
                                </span>
                            </td>
                            <td>{{consultation.consultationIdShort}}</td>
                            <td>{{consultation.patientName}}</td>
                            <td class="text-nowrap">
                                <router-link :to="{
                                'name': 'doctor-consultation-medicine-delivery-detail',
                                'params': {
                                    'id': consultation.consultationId
                                }
                            }">
                                   View Details
                                </router-link>
                            </td>
                        </tr>

                    </tbody>
                </table>

                <pagination v-model="pagination.currentPage" :totalPages="pagination.totalPages" :scrollPosition="pagination.scrollPosition">
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import {
    doctorConsultationNoPharmacyPrescriptionStatus,
    getEnumDisplay,
    getEnumBadgeClass
} from '@/config/enums';
import {
    convertToUserReadableDateTime
} from '@/utilities';
import pagination from '@/components/pagination';
export default {
    'name': 'ClinicPatientCheckIn',
    'components': {
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getList();
            });
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'consultationList': []
        };
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getList();
    },
    'methods': {
        getMedicineChargesStatus (statusId) {
            return getEnumDisplay(doctorConsultationNoPharmacyPrescriptionStatus, statusId);
        },
        getMedicineChargesBadgeClass (statusId) {
            return getEnumBadgeClass(doctorConsultationNoPharmacyPrescriptionStatus, statusId);
        },
        getList () {
            this.axios.post('Consultation/GetDoctorMedicineDelivery', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({
                data
            }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.consultationList = list.map((consultation) => ({
                    'dateTime': convertToUserReadableDateTime(consultation.ca),
                    'doctorName': consultation.dn,
                    'patientName': consultation.pn,
                    'status': consultation.s,
                    'consultationId': consultation.dc,
                    'consultationIdShort': consultation.dcis
                }));
            });
        }
    }
};
</script>

<style>

</style>
